/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  Stack,
  Typography,
} from '@mui/material';
import { Container } from '@mui/system';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import React, { useEffect, useState } from 'react';
import RatingItem from '../components/RatingItem';
import { fetchRatings } from '../http/ratingAPI';
import { getBranches } from '../http/clinicAPI';
import { useNavigate } from 'react-router-dom';
import { REVIEWS_ROUTE } from '../utils/consts';

const RatingPage = () => {
  const [reviews, setReviews] = useState([]);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [branches, setBranches] = useState([]);
  const [selectedBranchId, setSelectedBranchId] = useState('');
  const [selectedRating, setSelectedRating] = useState(``);
  const navigate = useNavigate();
  const handleChange = (event, value) => {
    setPage(value);
    fetchRatings(
      value,
      10,
      selectedRating,
      selectedBranchId
    ).then((data) => {
      setPageCount(+data.totalPages);
      setReviews(data.content);
    }).catch((error) => {
      console.error('Ошибка загрузки рейтингов:', error);
      setReviews([]);
      setPageCount(0);
    });
  };

  useEffect(() => {
    fetchRatings(page).then((data) => {
      setPageCount(+data.totalPages);
      setReviews(data.content);
    }).catch((error) => {
      console.error('Ошибка первичной загрузки рейтингов:', error);
      setReviews([]);
      setPageCount(0);
    });
    getBranches().then((data) => {
      setBranches(data);
    });
  }, []);

  return (
    <Container>
      <Button
        variant='text'
        size='small'
        startIcon={<ArrowBackIosNewIcon sx={{ fontSize: 14 }} />}
        sx={{ mt: 2, mb: 1, px: 0.5, minWidth: 'auto' }}
        onClick={() => navigate(REVIEWS_ROUTE)}
      >
        Назад
      </Button>

      <Typography variant='h6' sx={{ mb: 2 }}>
        Рейтинг
      </Typography>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          flexDirection: 'row',
          flexWrap: 'wrap',
          p: 0,
        }}
      >
        <Typography marginRight={2} marginBottom={2}>
          Фильтры
        </Typography>

        <FormControl sx={{ width: 200, mr: 2, mb: 2 }}>
          <InputLabel id='reviewLabel'>Оценка</InputLabel>
          <Select
            labelId='reviewLabel'
            value={selectedRating}
            label='Оценка'
            onChange={(event) => {
              setSelectedRating(event.target.value);
            }}
          >
            <MenuItem value=''>
              <em>None</em>
            </MenuItem>
            <MenuItem value={1}>1</MenuItem>
            <MenuItem value={2}>2</MenuItem>
            <MenuItem value={3}>3</MenuItem>
            <MenuItem value={4}>4</MenuItem>
            <MenuItem value={5}>5</MenuItem>
          </Select>
        </FormControl>

        <FormControl sx={{ width: 200, mr: 2, mb: 2 }}>
          <InputLabel id='branchLabel'>Филиал</InputLabel>
          <Select
            labelId='branchLabel'
            value={selectedBranchId}
            label='Филиал'
            onChange={(event) => {
              setSelectedBranchId(event.target.value);
            }}
          >
            <MenuItem value=''>
              <em>None</em>
            </MenuItem>
            {branches.map((branch) => (
              <MenuItem key={branch.id} value={branch.id}>
                {branch.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          variant='contained'
          sx={{ mr: 1, mb: 2 }}
          onClick={() => handleChange(null, page)}
          disableElevation={true}
        >
          Применить
        </Button>
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          flexDirection: 'row',
          flexWrap: 'wrap',
          p: 0,
          width: '100%',
        }}
      >
        {reviews.map((review) => (
          <RatingItem key={review.id} review={review} />
        ))}
      </Box>
      <Stack sx={{ mt: 2, alignItems: 'flex-start' }} spacing={2}>
        <Pagination count={pageCount} page={page} onChange={handleChange} />
      </Stack>
    </Container>
  );
};

export default RatingPage;
